import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Input,
  InputGroup,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import { SelectedModal } from "./SelectedModal";
import LandingHeader from "../Component/LandingHeader";
import ProductPageService from "../../../Services/ProductPageService";
import landingImage from "../../../assets/qrcode/Optimized-Landing.jpeg";
import Select from "react-select";
import "./top20.css";

const Top20Product = () => {

   const [modal, setModal] = useState(false);
   const toggleModal = () => setModal(!modal);

  const [topProduct, setTopProduct] = useState([]);
  const [keyWords, setKeyWords] = useState({
    restaurantName: "",
    itemName: "",
    category: "",
  });
  console.log("keyWords", keyWords);
  const [selectedModal, setSelectedModal]=useState({})
  const [values, setValues] = useState({
    restaurantName: null,
    category: null,
  });
  const [loading, setLoading] = useState(false);
  const [organization, setOrganization] = useState([]); //for select option
  const [categoryOption, setCategoryOption] = useState([]); //for select option
  const [debouncedFilters, setDebouncedFilters] = useState(keyWords);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  //initial render get organization and category
  useEffect(() => {
    const fetchOrgAndCategory = async () => {
      setLoading(true)
      try {
        const [org, category, products] = await Promise.all([
          ProductPageService.getOrganization(),
          ProductPageService.getCategory({}),
          // ProductPageService.getTop20Products({})
          // ProductPageService.getTop20Products({})
        ]);

        console.log(org);
        console.log(category);
        // console.log(products);
        // console.log(products);

        const structuredCategory = category.map((cat) => ({
          value: cat.categoryName,
          label: cat.categoryName,
        }));

        const structuredOrg = org.map((orgItem) => ({
          value: orgItem.organizationId,
          label: orgItem.organizationName,
        }));

        setOrganization(structuredOrg);
        setCategoryOption(structuredCategory);
        
        // setTopProduct(products);
      } catch (err) {
        console.log(err);
      }
      setLoading(false)
    };

    fetchOrgAndCategory();
  }, []);

  const handleFilterChange = (e) => {
    if (e !== null) {
      const { name, value } = e.target;

      setKeyWords((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // when any sreach keystroke is made, it debounce for some time
  useEffect(() => {
    setLoading(true)
    const timeoutId = setTimeout(() => {
      setDebouncedFilters(keyWords);
      setPageNum(1); // Reset to first page on filter change
    }, 700);
    // setLoading(true)
    

    return () => clearTimeout(timeoutId);
  }, [keyWords]);

  //after debouncing, the keyword is set as debounced filter
  useEffect(() => {
    const fetchFilteredData = async () => {
    setLoading(true)

      try {
        const res = await ProductPageService.getThisItem({
          pageNum: pageNum,
          pageSize: pageSize,
          restaurantName: debouncedFilters.restaurantName,
          itemName: debouncedFilters.itemName,
          categoryName: debouncedFilters.category,
        });
        setTopProduct(res);
        console.log(res);
      } catch (err) {
        console.log(err);
      }
    setLoading(false)

    };

    fetchFilteredData();
  }, [debouncedFilters]);

  //change the category option according to selected restro
  useEffect(() => {
    const fetchCategoryBasedOnRestro = async () => {
      try {
        let res = [];
        console.log("1");
        if (values.restaurantName !== null) {
          res = await ProductPageService.getCategory({
            OrgId: values.restaurantName.value,
          });

          console.log(res);
        } else {
          res = await ProductPageService.getCategory({});

          console.log(res);
        }

        const structuredCategory = res.map((cat) => ({
          value: cat.categoryName,
          label: cat.categoryName,
        }));

        setCategoryOption(structuredCategory);
      } catch (err) {
        console.log(err);
      }
    };

    if (categoryOption) {
      fetchCategoryBasedOnRestro();
    }
  }, [values.restaurantName]);

  console.log(values);
  console.log(keyWords);
  console.log(organization);

  // const selecggted = organization?.find(
  //   (opt) => opt.label === keyWords.restaurantName
  // );
  // console.log("selected", selecggted);

  const handleCardClick = (e)=>{
    toggleModal();
    setSelectedModal(e)
  }

  console.log(selectedModal)

  return (
   
    <div style={{ backgroundColor: "#FFFFFF" }}>
      <LandingHeader removeBlur={true} />

      {/* <div className=" titlesection CardsContainer  ">

      

     
         
     
      </div> */}

      <div
          className="titlesection CardsContainer gap-3 mb-2 py-2"
       
        >
          <Col sm={6} md={4} className="">
          <div className="fs-1">Top Products</div>
          </Col>

          <Col sm={6} md={3} className="">
            <InputGroup>
              <Input
                placeholder="Search item name..."
                value={keyWords.itemName}
                onChange={handleFilterChange}
                name="itemName"
              />
            </InputGroup>
          </Col>

         
        </div>

      <Row className=" d-flex CardsContainer  px-sm-5 justify-content-center "  >
        <Col md={10} className="">
        <div
          className="d-flex  justify-content-between gap-3 mb-2 py-2"
          style={{ borderBottom: "1px solid black" }}
        >
          <Col sm={6} md={4} className="">
            <Select
              isClearable
              className="z-3"
              options={categoryOption}
              value={values.category}
              onChange={(e) => {
                setKeyWords((prev) => ({
                  ...prev,
                  category: e == null ? "" : e.label,
                }));
                setValues((prev) => ({ ...prev, category: e }));
              }}
              placeholder="Filter by Category"
            />
          </Col>

          <Col sm={6} md={4} >
            <Select
              isClearable
              className="z-3"
              name="restaurantName"
              options={organization}
              value={values.restaurantName}
              onChange={(e) => {
                setKeyWords((prev) => ({
                  ...prev,
                  restaurantName: e == null ? "" : e.label,
                }));
                setValues((prev) => ({ ...prev, restaurantName: e }));
              }}
              placeholder="Filter by Restaurant Name"
            />
          </Col>
        </div>

        {/* <div className="col-12 px-4 red"> */}
        <Row   className="mb-4  " >

        {topProduct?.length > 0 ? (
          !loading ? (
            topProduct?.map((e, index) => (
               <Col key={index} xs="6" sm="6" md="4" className="top20Card " onClick={()=> handleCardClick(e)}>
                <Card>
                  <div className="col-12 ">
                    <img
                      alt="product-image"
                      src={
                        e?.cloudR2ImagePath
                          ? e?.cloudR2ImagePath?.getCDNUrl()
                          : landingImage
                      }
                      className="img-fluid w-100 object-fit-cover"
                      style={{ height: "10rem" }}
                    />
                  </div>

                  <CardBody>
                    <CardTitle tag="h5">{e.title}</CardTitle>

                    <CardSubtitle className="mb-2 text-muted" tag="h6">
                      <span>
                        <i class="ri-map-pin-line"></i>
                      </span>{" "}
                      {e.restaurantName}
                    </CardSubtitle>
                  </CardBody>
                </Card>
                 </Col>
            ))
          ) : (
            <div>Loading...</div>
          )
        ) : (
          <div className="" >No Products to fetch</div>
        )}
        {/* </div> */}
        </Row>

        </Col>
      </Row>


       <Modal isOpen={modal} toggle={toggleModal}>
              <ModalHeader toggle={toggleModal}>{selectedModal?.title}</ModalHeader>
              <ModalBody>

                <SelectedModal data={selectedModal} defaultImg={landingImage}/>
 
              </ModalBody>
        </Modal>
    </div>
  );
};

export default Top20Product;
